"use client";

import { useCallback } from "react";
import { parseAsBoolean, useQueryState } from "nuqs";

const projectSequencesParser = parseAsBoolean.withDefault(false);

export function useProjectSequencesSheet() {
  const [open, setOpen] = useQueryState(
    "projectSequences",
    projectSequencesParser,
  );

  const openProjectSequences = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const closeProjectSequences = useCallback(() => {
    return setOpen(false);
  }, [setOpen]);

  return {
    projectSequencesOpen: open,
    setProjectSequencesOpen: setOpen,
    openProjectSequences,
    closeProjectSequences,
  };
}
